import { Component } from "react"
import { Grid, Image, Divider, Header } from "semantic-ui-react";
import Map from "./Map"
// import './GeographicalReport.css'
import logo from '../../assets/logo.png'
import star from '../../assets/star2.png'

class GeographicalReport extends Component {

  getProjectTitle = () => {
    let title = '';
    this.props.projectState.project.title.forEach(item => {
        if (item.translation !== '') {
            title = item.translation + ' - ' + item.language;
        }
        if (item.language === 'EN' && item.translation !== '') {
            title = item.translation;
        }
    });
    return (title);
}
getProgrammePriority = () => {
  const programmePriorityCode = this.props.projectState.project.programmePriority.code;
  let programmePriorityTranslation
  this.props.projectState.project.programmePriority.title.forEach(item => {
      if (item.language === 'EN') {
          programmePriorityTranslation = item.translation;
      }
  });
  return (programmePriorityCode + ' - ' + programmePriorityTranslation);
}
  
  renderProjectInfos() {
    const project = this.props.projectState.project
    const lp = this.props.projectState.leadPartner
    return (
      <Grid.Column width={4}>
        <Image className="map-logo" src={logo} />
        <p className="map-project-title"> </p>
        <Divider horizontal>
          <Header as='h5'>
            Name
          </Header>
        </Divider>
        <p>{this.getProjectTitle()}</p>

        <Divider horizontal>
          <Header as='h5'>
            Acronym
          </Header>
        </Divider>
        <p>{project.acronym}</p>

        <Divider horizontal>
          <Header as='h5'>
            Lead Partner
          </Header>
        </Divider>
        <p>{lp.nameInEnglish} - {lp.addresses[0].country}</p>

        <Divider horizontal>
          <Header as='h5'>
            Priority
          </Header>
        </Divider>
        <p>{this.getProgrammePriority()}</p>

        <Divider horizontal>
          <Header as='h5'>
            Specific Objective
          </Header>
        </Divider>
        <p>{project.specificObjective.code} - {project.specificObjective.programmeObjectivePolicy}</p>

        <Divider horizontal>
          <Header as='h5'>
            Duration 
          </Header>
        </Divider>
        <p>{project.duration} Months{project.capCallDuration ? <span style={{ color: 'blue' }}> + {project.capCallDuration} Months (Capitalisation)</span> : null}</p>

        <Divider horizontal>
          <Header as='h5'>
            Total Eligible Cost
          </Header>
        </Divider>
        <p>{'€ ' + project.coFinancing.projectManagementCoFinancing.totalFundAndContribution.toLocaleString('en')}{project.capCallBudgetTEC ? <span style={{ color: 'blue' }}> + {'€ ' + project.capCallBudgetTEC.toLocaleString('en')} (Capitalisation)</span> : null}</p>

        <Divider horizontal>
          <Header as='h5'>
            Total ERDF requested
          </Header>
        </Divider>
        <p>{'€ ' + project.coFinancing.projectManagementCoFinancing.totalEuFundingAmount.toLocaleString('en')}{project.capCallBudgetERDF ? <span style={{ color: 'blue' }}> + {'€ ' + project.capCallBudgetERDF.toLocaleString('en')} (Capitalisation)</span> : null}</p>

        <Divider horizontal>
          <Header as='h5'>
            Legend
          </Header>
        </Divider>
        <div style={{ fontSize: 12, lineHeight: '22px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <img src={star} alt="Lead Partner" width="14" height="14" />
            <span>Lead Partner</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="12" height="18" viewBox="0 0 24 36"><path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 24 12 24s12-15 12-24C24 5.373 18.627 0 12 0z" fill="#609bc4" stroke="#fff" strokeWidth="1.5"/><circle cx="12" cy="12" r="5" fill="#fff"/></svg>
            <span>Project Partner</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="12" height="18" viewBox="0 0 24 36"><path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 24 12 24s12-15 12-24C24 5.373 18.627 0 12 0z" fill="#9b59b6" stroke="#fff" strokeWidth="1.5"/><circle cx="12" cy="12" r="5" fill="#fff"/></svg>
            <span>Cap Call Partner (existing)</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="12" height="18" viewBox="0 0 24 36"><path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 24 12 24s12-15 12-24C24 5.373 18.627 0 12 0z" fill="#f1c232" stroke="#fff" strokeWidth="1.5"/><circle cx="12" cy="12" r="5" fill="#fff"/></svg>
            <span>Cap Call Partner (new)</span>
          </div>
        </div>

      </Grid.Column>
    );
  }

  renderProjectMap() {
    const project = this.props.projectState.project
    return (
      <Grid.Column width={12}>
        <h1 className="map-title">{project.customIdentifier} {project.acronym}</h1>
        <div className="map-wrap">
          <Map />
        </div>
      </Grid.Column>
    );
  }

  render() {
    return (
      <div className="map-project-margin">
        <Grid columns={2}>
          {this.renderProjectInfos()}
          {this.renderProjectMap()}
        </Grid>
      </div>
    )
  }
}

export default GeographicalReport;